import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { MY_RFQ_KEY } from '@steelbuy/data-access';
import { MyRFQsContextProvider } from '../components/my-rfqs/MyRFQsContext';

export const RFQManagementView = () => {
    const queryClient = useQueryClient();
    useEffect(
        () => () => {
            queryClient.removeQueries({ queryKey: [MY_RFQ_KEY] });
        },
        []
    );
    return (
        <MyRFQsContextProvider>
            <Outlet />
        </MyRFQsContextProvider>
    );
};
